import CustomForm from '../CustomForm/CustomForm';

function Form(props) {    
    const form = {
        labelTitle: 'Editar',
        validateOnChange: true,
        showGoBackButton: false,
        containerType: 'dialog',
        fields:props.fields,
        values: props.values?props.values:false,
        customValidators:props.customValidators,
        handleSubmit: (fields,values) => {
            props.handleSubmit(fields,values,props.currentNode);
        }
    }

    return (
        <div>
            <CustomForm form={{...form}}  />
        </div>
    );
}
export default Form;
